import * as S from './styles'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { PAGE_PATHS } from '@/services/paths'

const Newsletter = () => {
  const { t } = useTranslation()

  return (
    <S.NewsletterWrapper>
      <S.NewsletterContainer className="mw-unsigned">
        <p>{t('subtitles.newsletter')}</p>
        <Link
          href={PAGE_PATHS.contact}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('buttons.demo')}
        </Link>
      </S.NewsletterContainer>
    </S.NewsletterWrapper>
  )
}

export default Newsletter
